const updateEquipmentsStr = {
  toastr: 'Updated equipment',
  toastrError: 'Equipment already registered',
  toastrError2: 'Error editing Equipment',
  serialNumberError: 'There is already a device with the same serial number for this site',
};

export default updateEquipmentsStr;
